const { getCurrentDate } = require('./getCurrentDate')
const { getCurrentTime } = require('./getCurrentTime')

/**
 * Visszaadja az aktuális dátumot és időt.
 * @param {string} separator - A szeparátor a dátum és az idő között.
 * @returns {string} Az ISO teljes dátum: YYYY-mm-dd hh:ii:ss.
 */
module.exports.getCurrentDateAndTime = function getCurrentDateAndTime (separator = ' ') {
  const date = getCurrentDate()
  const time = getCurrentTime()

  return `${ date }${ separator }${ time }`
}
